const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tptt-can-mail-sea/search', { params })
  },
  save ({ state, commit, rootState }, params) {
    return rootState.axios.post('/tpsp/v1frontend/tptt-can-mail-sea/save', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
